module.exports = __webpack_public_path__ + "static/media/Medical Questionnaire.4963a2f6.svg";